export default __webpack_public_path__ + "static/media/delievers10.d5dc7944.jpg";